import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {ButtonComponentModule} from 'app/components/ui/button/item.module';
import {ModalHeaderComponentModule} from 'app/components/ui/modal-header/item.module';
import {ModalFooterComponentModule} from 'app/components/ui/modal-footer/item.module';
import {ChatEditModalComponent} from 'app/components/shared/chatModal/components/chatEditModal/item';
import {ChatInfoModalComponent} from 'app/components/shared/chatModal/components/chatInfoModal/item';
import {ChatUsersModalComponent} from 'app/components/shared/chatModal/components/chatUsersModal/item';
import {DirectivesModule} from 'app/core/directives/directives.module';
import {InputComponentModule} from 'app/components/form/input/item.module';
import {TabsComponentModule} from 'app/components/ui/tabs/item.module';
import {ChatActionModalComponent} from 'app/components/shared/chatModal/components/chatActionModal/item';
import {IconComponentModule} from 'app/components/ui/icon/item.module';
import {AvatarComponentModule} from '../../ui/avatar/item.module';
import {ReactiveFormsModule} from '@angular/forms';
import {ChatInfoContentComponent} from "./components/chatInfoModal/components/chatInfoContent/item";
import {AccountableItemComponentModule} from "../../../pages/accountable/components/accountable-item/item.module";
import {ListComponentModule} from "../../ui/list/item.module";
import {FileItemsComponentModule} from "../../ui/file-items/item.module";

// @todo chat move all chat components to chat

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ButtonComponentModule,
    ModalHeaderComponentModule,
    DirectivesModule,
    InputComponentModule,
    ModalFooterComponentModule,
    TabsComponentModule,
    IconComponentModule,
    AvatarComponentModule,
    ReactiveFormsModule,
    AccountableItemComponentModule,
    ListComponentModule,
    FileItemsComponentModule,
  ],
  exports: [
    ChatEditModalComponent,
    ChatInfoModalComponent,
    ChatUsersModalComponent,
    ChatActionModalComponent
  ],
  declarations: [
    ChatEditModalComponent,
    ChatInfoModalComponent,
    ChatUsersModalComponent,
    ChatActionModalComponent,
    ChatInfoContentComponent
  ],
  providers: [],
})
export class ChatModalModule {
}
